import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, FreeMode } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/free-mode';
import "./LearningSystem.css";

// Import images
import imgSystem1 from "../../../assets/images/home/pic_page5_1.webp";
import imgSystem1Zh from "../../../assets/images/home/pic_page5_1_zh.webp";
import imgSystem2 from "../../../assets/images/home/pic_page5_2.webp";
import imgSystem3 from "../../../assets/images/home/pic_page5_3.webp";
import imgSystem3Zh from "../../../assets/images/home/pic_page5_3_zh.webp";
import imgSystem4 from "../../../assets/images/home/pic_page5_4.webp";
import imgSystem4Zh from "../../../assets/images/home/pic_page5_4_zh.webp";

const LearningSystem = () => {
  const { t, i18n } = useTranslation();
  const isZh = i18n.language?.startsWith("zh");
  const cardsData = t("home.learning_system.cards", { returnObjects: true });
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 576);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 576);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const images = [
    isZh ? imgSystem1Zh : imgSystem1,
    imgSystem2,
    isZh ? imgSystem3Zh : imgSystem3,
    isZh ? imgSystem4Zh : imgSystem4
  ];

  const renderCards = () => {
    if (!Array.isArray(cardsData)) return null;

    if (isMobile) {
      return (
        <Swiper
          modules={[Pagination, FreeMode]}
          spaceBetween={24}
          slidesPerView={"auto"}
          centeredSlides={false}
          slidesOffsetBefore={40}
          slidesOffsetAfter={40}
          freeMode={true}
          pagination={{ clickable: true }}
          className="system-swiper"
        >
          {cardsData.map((card, index) => (
            <SwiperSlide key={index}>
              <div className="system-card">
                <div className="card-image-box">
                  <img src={images[index]} alt={card.title} className="card-feature-img" />
                </div>
                <div className="card-info">
                  <h3 className="card-title global-subtitle">{card.title}</h3>
                  <p className="card-desc global-text">{card.desc}</p>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      );
    }

    return (
      <div className="system-grid">
        {cardsData.map((card, index) => (
          <div key={index} className="system-card">
            <div className="card-image-box">
              <img src={images[index]} alt={card.title} className="card-feature-img" />
            </div>
            <div className="card-info">
              <h3 className="card-title global-subtitle">{card.title}</h3>
              <p className="card-desc global-text">{card.desc}</p>
            </div>
          </div>
        ))}
      </div>
    );
  };

  return (
    <section className="learning-system-wrapper">
      <div className="learning-system-header">
        <h2 className="system-title global-title">{t("home.learning_system.title")}</h2>
        <p className="system-subtitle global-text">{t("home.learning_system.subtitle")}</p>
      </div>

      {renderCards()}
    </section>
  );
};

export default LearningSystem;
